import { i18n } from '@/locales';
const t = i18n.t.bind(i18n);
const lc = 'views.worker_fee_per_store_group_setting.';
export const workerFeePerStoreGroupSettingGroupTableHeader = [
    {
        title: t(`${lc}group_setting_table.group_name`),
        align: 'start',
        sortable: true,
        value: 'name',
        width: 260,
    },
    {
        title: t(`${lc}group_setting_table.day_fee_count`),
        align: 'end',
        sortable: false,
        width: 146,
    },
    {
        title: t(`${lc}group_setting_table.store_in_group`),
        align: 'center',
        sortable: false,
        width: 150,
    },
    {
        title: t(`${lc}group_setting_table.edit_and_delete`),
        align: 'center',
        sortable: false,
    },
];
export const workerFeePerStoreGroupSettingOptionTableHeader = [
    // 대행료 시작
    {
        title: t(`${lc}option_setting_table.from_amount`),
        align: 'center',
        sortable: false,
        width: 160,
    },
    // 대행료 종료
    {
        title: t(`${lc}option_setting_table.to_amount`),
        align: 'center',
        sortable: false,
        width: 160,
    },
    // 수수료 정액
    {
        title: t(`${lc}option_setting_table.fee`),
        align: 'center',
        sortable: false,
        width: 160,
    },
    // 수수료 정률
    {
        title: t(`${lc}option_setting_table.rate`),
        align: 'center',
        sortable: false,
        width: 140,
    },
    {
        title: t(`${lc}option_setting_table.edit_and_delete`),
        align: 'end',
        sortable: false,
    },
];
export const storeListTableHeader = [
    {
        title: t(`${lc}store_setting_dialog.store_list_table.store_name`),
        align: 'start',
        sortable: false,
    },
    {
        title: t(`${lc}store_setting_dialog.store_list_table.store_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}store_setting_dialog.store_list_table.delete`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
export const availableStoreListTableHeader = [
    {
        title: t(`${lc}store_setting_dialog.store_list_table.store_name`),
        align: 'start',
        sortable: false,
    },
    {
        title: t(`${lc}store_setting_dialog.store_list_table.store_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}store_setting_dialog.store_list_table.group_name`),
        align: 'start',
        sortable: false,
        width: 180,
    },
    {
        title: t(`${lc}store_setting_dialog.store_list_table.add`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
